import React, { Fragment } from "react";
import SupportLayout from "components/page_components/SupportPage/SupportLayout";
import { NextSeo } from "next-seo";
import * as page_template from "utils/helpers/pages_template";
import Link from "next/link";
import { useLang } from "hooks/useLang";

interface IContent {
  index: number;
  href: string;
  title: string;
  wlc?: string;
  content2?: string;
  content?: string;
  items?: string[];
  items2?: string[];
  content3?: string;
  items3?: string[];
  content4?: string;
}

export default function TermsOfUse() {
  const { t } = useLang();
  const page_title = t("USER_TAC_TITLE");
  const SEO = page_template.page_SEO(page_title);
  const sideList: Array<IContent> = [
    { index: 1, href: "#introduction", title: "termOfUse_introduction" },
    { index: 2, href: "#cookies", title: "COOKIES_TITLE" },
    { index: 3, href: "#license", title: "termOfUse_license" },
    { index: 4, href: "#hyperlinking", title: "termOfUse_hyperLink" },
    { index: 5, href: "#iFrames", title: "termOfUse_iframe" },
    { index: 6, href: "#liability", title: "termOfUse_content" },
  ];

  const pageContent: Array<IContent> = [
    {
      index: 1,
      href: "introduction",
      title: "termOfUse_introduction",
      //wlc: "welcomeToPassTickets",
      content2: "termOfUse_desc_1",
    },
    {
      index: 2,
      href: "cookies",
      title: "COOKIES_TITLE",
      content: "termOfUse_desc_2",
    },
    {
      index: 3,
      href: "license",
      title: "termOfUse_license",
      content: "termOfUse_desc_3",
      // items: [
      //   "termOfUse_desc_3_li_1",
      //   "termOfUse_desc_3_li_2",
      //   "termOfUse_desc_3_li_3",
      //   "termOfUse_desc_3_li_4",
      // ],
      // content2: "termOfUse_desc_4",
      // items2: [
      //   "termOfUse_desc_4_li_1",
      //   "termOfUse_desc_4_li_2",
      //   "termOfUse_desc_4_li_3",
      //   "termOfUse_desc_4_li_4",
      // ],
    },

    {
      index: 4,
      href: "hyperlinking",
      title: "termOfUse_hyperLink",
      content: "termOfUse_desc_4",
      // items: [
      //   "termOfUse_desc_6_li_1",
      //   "termOfUse_desc_6_li_2",
      //   "termOfUse_desc_6_li_3",
      //   "termOfUse_desc_6_li_4",
      //   "termOfUse_desc_6_li_5",
      // ],
      // content2: "termOfUse_desc_7",
      // items2: [
      //   "termOfUse_desc_7_li_1",
      //   "termOfUse_desc_7_li_2",
      //   "termOfUse_desc_7_li_3",
      //   "termOfUse_desc_7_li_4",
      //   "termOfUse_desc_7_li_5",
      //   "termOfUse_desc_7_li_6",
      //   "termOfUse_desc_7_li_7",
      // ],
      // content3: "termOfUse_desc_8",
      // items3: [
      //   "termOfUse_desc_8_li_1",
      //   "termOfUse_desc_8_li_2",
      //   "termOfUse_desc_8_li_3",
      //   "termOfUse_desc_8_li_4",
      // ],
      // content4: "termOfUse_desc_9",
    },
    {
      index: 5,
      href: "iFrames",
      title: "termOfUse_iframe",
      content: "termOfUse_desc_5",
    },
    {
      index: 6,
      href: "liability",
      title: "termOfUse_content",
      content: "termOfUse_desc_6",
    },
  ];

  return (
    <Fragment>
      <NextSeo {...SEO} />
      <SupportLayout
        Title={t("USER_TAC_TITLE")}
        TitlePa="pt-[13.375rem]"
        showSearch={false}
        //supportText={t("terms_intro")}
      >
        <div
          className={`flex gap-[1.1875rem] overflow-hidden px-5 md:gap-[5.1875rem] md:px-[4.125rem] `}
        >
          <div className="sticky  top-0 mb-36 hidden flex-col space-y-[1.875rem] self-start pt-[7.125rem] md:flex">
            {sideList.map((item) => (
              <Link
                key={item.index}
                passHref
                href={item.href}
                className="transition-colors"
                legacyBehavior
              >
                <span className="cursor-pointer hover:text-primary dark:hover:text-blue-400">
                  {`${item.index}. ${t(item.title)}`}
                </span>
              </Link>
            ))}
          </div>

          <div className="mb-[7.75rem] max-w-[51.875rem] pt-[2rem]">
            {/* <p className="terms-of-use-heading m-2 text-[1.375rem] dark:text-white md:text-[1.875rem]">
                            {t("USER_TAC_TITLE")}
                        </p> */}
            {pageContent.map((item) => (
              <div key={item.href} id={item.href}>
                <p
                  className="terms-of-use-heading mt-4 text-[1.25rem] dark:text-gray-400 md:text-2xl"
                  id={item.href}
                >
                  {item.index}. {t(item.title)}
                </p>
                {item.wlc && (
                  <p className="terms-of-use-heading mt-[1.9rem] text-[1.25rem] dark:text-white md:text-[1.375rem]">
                    {t(item.wlc!)}
                  </p>
                )}

                <div className="terms-of-use-text mt-[1.6rem]">
                  {item.content && <>{t(item.content!)}</>}
                  <ul className="terms-of-use-text ml-9 mt-[1.125rem] list-inside list-disc">
                    {item.items?.map((it, i: number) => (
                      <Fragment key={i}>
                        {it && <li id={it}>{t(it)}</li>}
                      </Fragment>
                    ))}
                  </ul>
                </div>

                <div>
                  <div className="terms-of-use-text mt-[1.125rem]">
                    {item.content2 && <>{t(item.content2!)}</>}
                    {/* {t(item.content2!)} */}
                    <ul
                      className={`terms-of-use-text ml-9 mt-[1.125rem] list-inside list-disc`}
                    >
                      {item.items2?.map((item, i: number) => (
                        <Fragment key={i}>
                          {item && <li key={i}>{t(item)}</li>}
                        </Fragment>
                      ))}
                    </ul>
                  </div>
                </div>

                <div>
                  <div className="terms-of-use-text mt-[1.125rem]">
                    {item.content3 && <>{t(item.content3!)}</>}
                    <ul
                      className={`terms-of-use-text ml-9 mt-[1.125rem] list-inside list-disc`}
                    >
                      {item.items3?.map((item, i: number) => (
                        <Fragment key={i}>
                          {item && <li key={i}>{t(item)}</li>}
                        </Fragment>
                      ))}
                    </ul>
                  </div>
                </div>

                <div>
                  {item.content4 && (
                    <p className="terms-of-use-text mt-[1.125rem]">
                      {t(item.content4!)}
                    </p>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>
      </SupportLayout>
    </Fragment>
  );
}
